<template>

    <div class="greenfox">

        <div class="greenfox__center">

            <div class="greenfox__tag">{{$t('greenfox_card_new_app')}}</div>

            <p class="greenfox__title">{{$t('greenfox_card_title')}}</p>

            <p class="greenfox__text">{{$t('greenfox_card_description')}}</p>

        </div>

        <div class="greenfox__center">

            <div class="greenfox__blurry">

                <div class="greenfox__img-background">
                    <img src="/img/cards/t-shirt.svg" class="greenfox__img">
                </div>

                <div class="greenfox__blurry__text-container">
                    <p class="greenfox__blurry__title">{{$t('greenfox_card_basic_tshirt')}}</p>
                    <p class="greenfox__blurry__text">{{$t('greenfox_card_price_CO2')}}</p>
                </div>
            </div>
        </div>

        <div class="greenfox__center">

            <button class="greenfox__cta" @click="goLink">
                <p class="greenfox__cta__text">{{$t('greenfox_card_cta')}}</p>
                <img src="/img/icons/arrow-square-up-right-lilac.svg" class="greenfox__cta__icon">
            </button>
        </div>


    </div>

</template>

<script>

import Tag from '@/modules/tag'

export default {

    name: 'card-template-greenfox',

    props: {

        card: {
            type: Object,
            default: {}
        },

        position: {
            type: Number,
            default: -1
        }
    },

    watch: {

        position: function (position) {
            if (position === 1) {

                Tag.pageViewAll(this, this.card.tag)
            }
        }
    },

    methods: {

        goLink() {

            Tag.clickAll(this, 'download_greenfox', this.card.tag)

            window.open(this.card.cta, '_blank', 'rel="noopener,noreferrer,nofollow"')

        }
    }
}

</script>

<style lang="scss" scoped>

.greenfox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 12px;
    background-color: #774eec;
    padding: 24px 16px;
    background-image: url("/img/background/cards-greenfox.png");
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: bottom;
    background-size: contain;

    &__center {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &__tag {
        width: fit-content;
        padding: 4px 10px;
        border-radius: 16px;
        background-color: $aquamarine;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.33;
        color: $white;
    }

    &__title {
        margin-top: 12px;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        text-align: center;
        color: $white;
        max-width: 300px;
    }

    &__text {
        font-size: 17px;
        line-height: 1.29;
        text-align: center;
        color: $white;
    }

    &__blurry {
        width: 100%;
        padding: 16px;
        border-radius: 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        -webkit-backdrop-filter: blur(16px);
        backdrop-filter: blur(16px);
        background-color: rgba(255, 255, 255, 0.35);
        max-width: 300px;

        &__text-container {
            text-align: left;
            color: $white;
        }

        &__title {
            font-size: 18px;
            font-weight: 600;
            line-height: 1.11;
            letter-spacing: 0.54px;
        }

        &__text {
            font-size: 16px;
            line-height: 1.13;
            letter-spacing: 0.48px;
        }
    }

    &__img-background {
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background-color: $white;
        margin-right: 16px;
    }

    &__img {
        width: 32px;
        object-fit: contain;
    }

    &__cta {
        cursor: pointer;
        width: 100%;
        border-radius: 32px;
        background-color: $white;
        padding: 16px 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 300px;

        &__text {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            color: #774eec;
            margin-right: 4px;
        }

        &__img {
            width: 24px;
            object-fit: contain;
        }
    }
}

</style>
